import React from 'react';
import './AboutModal.css';
import VERSION_CONFIG from '../../config/version';

const AboutModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="about-modal-overlay" onClick={handleOverlayClick}>
      <div className="about-modal">
        {/* App Icon */}
        <div className="about-modal-icon">
          <svg width="64" height="64" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(30,40)">
              <rect x="0" y="10" width="12" height="50" fill="var(--primary-brand)" rx="2"/>
              <rect x="18" y="20" width="12" height="40" fill="var(--primary-brand)" opacity="0.8" rx="2"/>
              <rect x="36" y="0" width="12" height="60" fill="var(--primary-brand)" opacity="0.6" rx="2"/>
            </g>
          </svg>
        </div>

        {/* App Name */}
        <h1 className="about-modal-title">Data Intelligence</h1>
        <p className="about-modal-subtitle">AI-Powered Analytics Platform</p>

        {/* Version Info */}
        <div className="about-modal-info">
          <div className="about-info-row">
            <span className="about-info-label">Version</span>
            <span className="about-info-value">{VERSION_CONFIG.FRONTEND_VERSION}</span>
          </div>
          <div className="about-info-row">
            <span className="about-info-label">Developer</span>
            <span className="about-info-value">Datacenter AI</span>
          </div>
          <div className="about-info-row">
            <span className="about-info-label">Build</span>
            <span className="about-info-value">{VERSION_CONFIG.FRONTEND_BUILD_DATE}</span>
          </div>
        </div>

        {/* Links */}
        <div className="about-modal-links">
          <a
            href="https://github.com/yourusername/datacenterai/releases"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link-button"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            What's New
          </a>
          <a
            href="https://docs.datacenterai.com"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link-button"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            User Guide
          </a>
        </div>

        {/* Copyright */}
        <p className="about-modal-copyright">
          © 2026 Datacenter. All rights reserved.
        </p>

        {/* Close Button */}
        <button className="about-modal-close" onClick={onClose} aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AboutModal;
